import Api from "../Api";

const basePath = '/call-center';

export default {

    getCustomerVehicleByVin: (vin) => Api.get(`${basePath}/vin/${vin}`),

    getIvsVehicles: (vin) => Api.get(`${basePath}/ivs/${vin}`),
}



// WEBPACK FOOTER //
// ./src/services/api/CallCenterService.js